import { AnyAction, createReducer } from '@reduxjs/toolkit';
import {
	userTeamAccessVerify,
	userTeamAccessVerifyRejected,
	userTeamAccessVerifyResolved,
} from '../actions/userTeamAccess.actions';
import { injectProject } from '../actions/authenticationContext.actions';

import { STATUS_ENUM } from '../types/reducers.types';
import { UserTeamAccessState } from '../types/userTeamAccess.types';

export const initialUserTeamAccessState: UserTeamAccessState = {
	enabled: false,
	status: STATUS_ENUM.IDLE,
	canCreateInfo360Hubs: false,
	isHubAdmin: null,
	hubExists: null,
	projectsExists: null,
	hasInfo360Licenses: null,
	teamInfo: '',
	hubAccountId: '',
};

export interface UserTeamAccessReducer {
	[x: string]: (
		state: UserTeamAccessState,
		action: AnyAction,
	) => UserTeamAccessState | undefined;
}

const reducer: UserTeamAccessReducer = {
	[userTeamAccessVerify.toString()]: state => ({
		...state,
		status: STATUS_ENUM.PENDING,
		enabled: true,
	}),
	[userTeamAccessVerifyResolved.toString()]: (state, action) => ({
		...state,
		...action.payload,
		status: STATUS_ENUM.SUCCESS,
	}),
	[userTeamAccessVerifyRejected.toString()]: (state, action) => ({
		...state,
		...initialUserTeamAccessState,
		status: STATUS_ENUM.ERROR,
	}),
	[injectProject.toString()]: (state, action) => {
		return { ...state, ...initialUserTeamAccessState };
	},
};

export default createReducer(initialUserTeamAccessState, reducer);
